/*export let defaultVariables = {
    url: "http://127.0.0.1:8000/api",
    backend: "http://127.0.0.1:8000/",
    uploads: "http://127.0.0.1:8000/uploads",
    React:"http://localhost:3000",
    website: "http://localhost:3000",
};*/

export let defaultVariables = {
  url: "http://192.168.1.113:8000/api",
  backend: "http://192.168.1.113:8000/",
  uploads: "http://192.168.1.113:8000/uploads",
  React: "http://192.168.1.113:3000",
  website: "http://192.168.1.113:3000",
};
